import { ActionsGlobalMediaLibrary } from "./ActionsGlobalMediaLibrary";
import { callWebUtils } from "../../Components/CampaignMembers/helpers";

export const ActionsListenersGlobalMediaLibrary = ({ database }) => {
  ActionsGlobalMediaLibrary.getCloudinaryImagesByCompanyId.listen(function (companyId) {
    return callWebUtils(this, "getCloudinaryImagesByCompanyId", [companyId]);
  });

  ActionsGlobalMediaLibrary.getOldUploadedImages.listen(function (
    orgaName,
    companyName,
    orgaId,
    campaignId = null
  ) {
    return callWebUtils(this, "getUploadedImages", [{ orgaName, companyName, orgaId, campaignId }]);
  });

  ActionsGlobalMediaLibrary.getOldUploadedLogos.listen(function (
    orgaName,
    companyName,
    orgaId,
    campaignId = null
  ) {
    return callWebUtils(this, "getUploadedLogos", [{ orgaName, companyName, orgaId, campaignId }]);
  });

  ActionsGlobalMediaLibrary.likeCloudinaryAsset.listen(function (payload) {
    return callWebUtils(this, "likeCloudinaryAsset", [payload]);
  });
};
